<template>
  <!--begin::Content wrapper-->
  <div class="d-flex flex-column flex-column-fluid">
    <!--begin::Toolbar-->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <div
        id="kt_app_toolbar_container"
        class="app-container container-fluid d-flex flex-stack"
      >
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <h1
            class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0"
          >
            منصة أكاديميا Academia
          </h1>
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <li class="breadcrumb-item text-muted">
              <a href="#" class="text-muted text-hover-primary">الصفحة الرئيسية</a>
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">شروط الخدمة</li>
          </ul>
        </div>
      </div>
    </div>
    <!--end::Toolbar-->

    <!--begin::Content-->
    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div class="row g-5 g-xl-10 mb-5 mb-xl-10" id="section-content">
          <div class="col-12">
            <div class="card shadow-lg border-0 rounded-4 h-100 bg-light">
              <div class="card-body p-5">
                <!-- العنوان والايقونة -->
                <div class="text-center mb-5">
                  <div
                    href="#"
                    class="mb-0 mb-lg-2 custom-logo"
                    style="text-align: center"
                  >
                    <img
                      alt="Logo"
                      src="assets/img/logo-dark.png"
                      class="h-60px h-lg-75px"
                    />
                  </div>
                  <div
                    class="d-inline-flex align-items-center justify-content-center bg-success bg-opacity-10 rounded-circle p-4 shadow-sm"
                  >
                    <i
                      class="fas fa-file-contract fa-3x text-success"
                      style="font-size: 18px"
                    ></i>
                  </div>
                  <h2 style="font-weight: 700" class="fw-bold mt-3 text-dark">
                    شروط الخدمة | Terms of Service
                  </h2>
                  <p class="text-muted">تاريخ النفاذ / Effective Date: 21/09/2025</p>
                </div>

                <!-- المحتوى باللغتين جنب بعض -->
                <div class="row gy-5">
                  <!-- Arabic Terms -->
                  <div class="col-lg-6 terms-col-ar pe-lg-4" style="padding: 16px 50px">
                    <div class="terms-content" dir="rtl">
                      <p class="text-dark">
                        مرحبًا بك في منصة أكاديميا، تنظم هذه الشروط "شروط الخدمة" استخدامك
                        لمنصتنا التعليمية الإلكترونية، تطبيقات الهاتف، والخدمات ذات الصلة.
                        باستخدامك للخدمات، فإنك توافق على الالتزام بهذه الشروط. إذا لم
                        توافق، فلا يمكنك استخدام الخدمات.
                      </p>

                      <h5
                        style="font-weight: 700 !important"
                        class="fw-bold mt-4 text-dark"
                      >
                        1- الحسابات
                      </h5>
                      <ul>
                        <li>أنت مسؤول عن الحفاظ على سرية بيانات الدخول الخاصة بك.</li>
                        <li>توافق على تقديم معلومات دقيقة ومكتملة ومحدثة.</li>
                        <li>تتحمل المسؤولية عن جميع الأنشطة التي تتم عبر حسابك.</li>
                      </ul>

                      <h5
                        style="font-weight: 700 !important"
                        class="fw-bold mt-4 text-dark"
                      >
                        2- استخدام الخدمات
                      </h5>
                      <ul>
                        <li>
                          يمكن استخدام الخدمات لأغراض قانونية فقط ووفقًا لهذه الشروط.
                        </li>
                        <li>لا يجوز نسخ أو إعادة توزيع أو إعادة بيع الدورات بدون إذن.</li>
                        <li>عدم التدخل في عمل المنصة أو محاولة الوصول غير المصرح به.</li>
                      </ul>

                      <h5
                        style="font-weight: 700 !important"
                        class="fw-bold mt-4 text-dark"
                      >
                        3- الدورات والمحتوى
                      </h5>
                      <ul>
                        <li>
                          المحتوى (الدروس، الفيديوهات، الاختبارات، إلخ) مملوك لمنصة
                          أكاديميا ومرخص من شركائنا.
                        </li>
                        <li>
                          شراء دورة يمنحك ترخيصًا محدودًا وغير قابل للنقل للاستخدام الشخصي
                          فقط.
                        </li>
                        <li>
                          لا يجوز إعادة إنتاج أو توزيع أو عرض المحتوى علنًا بدون إذن.
                        </li>
                      </ul>

                      <h5
                        style="font-weight: 700 !important"
                        class="fw-bold mt-4 text-dark"
                      >
                        4- المدفوعات والاسترداد
                      </h5>
                      <ul>
                        <li>بعض الخدمات مجانية، والبعض الآخر يتطلب دفع رسوم اشتراك.</li>
                        <li>الأسعار تظهر قبل الاشتراك وقد تتغير حسب تقديرنا.</li>
                        <li>
                          سياسة الاسترداد ستُعرض بوضوح عند الدفع. ما لم يُذكر خلاف ذلك،
                          الاشتراكات غير قابلة للاسترداد.
                        </li>
                        <li>
                          مدة الاشتراك يتم تحديدها من قبلنا وبالاتفاق مع المحاضر، ويمكنك
                          الاستفسار عن مدة الصلاحية قبل الاشتراك.
                        </li>
                      </ul>

                      <h5
                        style="font-weight: 700 !important"
                        class="fw-bold mt-4 text-dark"
                      >
                        5- شروط المحاضرين
                      </h5>
                      <ul>
                        <li>
                          إذا قدمت محتوى، فإنك تمنحنا ترخيصًا باستضافته واستخدامه وتوزيعه
                          والترويج له على المنصة.
                        </li>
                        <li>
                          تتحمل المسؤولية عن التزام المحتوى بالقوانين وعدم انتهاكه لحقوق
                          الغير.
                        </li>
                      </ul>

                      <h5
                        style="font-weight: 700 !important"
                        class="fw-bold mt-4 text-dark"
                      >
                        6- الملكية الفكرية
                      </h5>
                      <p class="text-dark">
                        كامل المحتوى وجميع العلامات التجارية والشعارات وميزات المنصة
                        مملوكة لمنصة أكاديميا. لا يجوز استخدام ملكيتنا الفكرية بدون إذن
                        كتابي مسبق من قبلنا.
                      </p>

                      <h5
                        style="font-weight: 700 !important"
                        class="fw-bold mt-4 text-dark"
                      >
                        7- الخصوصية
                      </h5>
                      <p class="text-dark">
                        يخضع استخدامك للخدمات أيضًا لسياسة الخصوصية الخاصة بنا. قد نجمع
                        ونعالج البيانات الشخصية لتشغيل الخدمات وتحسينها.
                      </p>

                      <h5
                        style="font-weight: 700 !important"
                        class="fw-bold mt-4 text-dark"
                      >
                        8- إنهاء الخدمة
                      </h5>
                      <ul>
                        <li>يمكننا تعليق أو إنهاء حسابك إذا انتهكت هذه الشروط.</li>
                        <li>يمكن للطالب حذف حسابه في أي وقت عبر التواصل مع الدعم.</li>
                      </ul>

                      <h5
                        style="font-weight: 700 !important"
                        class="fw-bold mt-4 text-dark"
                      >
                        9- إخلاء المسؤولية
                      </h5>
                      <ul>
                        <li>لا نضمن أن الدورات أو المحتوى سيلبي توقعاتك.</li>
                        <li>غير مسؤولين عن النقاشات داخل المجموعات الخاصة بالمحاضرين.</li>
                        <li>
                          كما أننا غير مسؤولين عن توفير المنهج كمذكرات أو كتب أو صيغ PDF،
                          ويعتمد ذلك على المحاضر إن أراد توفيرها.
                        </li>
                        <li>تُقدّم الخدمات "كما هي" بدون أي ضمانات.</li>
                      </ul>

                      <h5
                        style="font-weight: 700 !important"
                        class="fw-bold mt-4 text-dark"
                      >
                        10- حدود المسؤولية
                      </h5>
                      <p class="text-dark">
                        إلى الحد الأقصى الذي يسمح به القانون، لن نكون مسؤولين عن أي أضرار
                        غير مباشرة أو تبعية.
                      </p>

                      <h5
                        style="font-weight: 700 !important"
                        class="fw-bold mt-4 text-dark"
                      >
                        11- التغييرات على الشروط
                      </h5>
                      <p class="text-dark">
                        قد نقوم بتحديث هذه الشروط من وقت لآخر. استمرارك في استخدام الخدمات
                        بعد التغييرات يعني قبولك للشروط المحدثة.
                      </p>

                      <h5
                        style="font-weight: 700 !important"
                        class="fw-bold mt-4 text-dark"
                      >
                        12- تواصل معنا
                      </h5>
                      <p class="text-dark">
                        للاستفسارات، يمكنك التواصل معنا عبر:
                        <a
                          href="https://t.me/Academia_messeges_bot"
                          target="_blank"
                          class="fw-semibold"
                          >بوت الدعم</a
                        >
                      </p>
                      <p class="text-dark">
                        📍 المكان: مركز أكاديميا – فرع الجامعة، مقابل مدرجات كلية الهندسة
                        بجامعة طرابلس، بمحاذاة السياج الخارجي لمسجد الجامعة.
                      </p>
                      <a
                        href="https://maps.apple.com/?auid=14457113495649267365&ll=32.857007,13.215420&lsp=7618&q=Dropped%20Pin&t=m"
                        target="_blank"
                        style="font-size: 13px !important; padding: 10px !important"
                        class="btn btn-success mt-3 px-4 py-4 fw-bold fs-5 rounded-pill d-inline-flex align-items-center shadow-sm"
                      >
                        <i class="fas fa-location-dot me-2"></i>
                        عرض على الخريطة
                      </a>
                    </div>
                  </div>

                  <!-- English Terms -->
                  <div class="col-lg-6 terms-col-en ps-lg-4" style="padding: 16px 50px">
                    <div class="terms-content" dir="ltr">
                      <p class="text-dark">
                        Welcome to Academia Platform. These terms ("Terms of Service")
                        govern your use of our online educational platform, mobile
                        applications, and related services. By using our services, you
                        agree to be bound by these terms. If you do not agree, you may not
                        use the services.
                      </p>

                      <h5 style="font-weight: 700" class="fw-bold mt-4 text-dark">
                        1. Accounts
                      </h5>
                      <ul>
                        <li>
                          You are responsible for keeping your login credentials
                          confidential.
                        </li>
                        <li>
                          You agree to provide accurate, complete, and up-to-date
                          information.
                        </li>
                        <li>
                          You are liable for all activities carried out through your
                          account.
                        </li>
                      </ul>

                      <h5 style="font-weight: 700" class="fw-bold mt-4 text-dark">
                        2. Use of Services
                      </h5>
                      <ul>
                        <li>
                          Services may only be used for lawful purposes and in accordance
                          with these terms.
                        </li>
                        <li>
                          You may not copy, redistribute, or resell courses without
                          permission.
                        </li>
                        <li>
                          You may not interfere with or disrupt the platform’s operation.
                        </li>
                        <li>You may not attempt unauthorized access to our systems.</li>
                      </ul>

                      <h5 style="font-weight: 700" class="fw-bold mt-4 text-dark">
                        3. Courses and Content
                      </h5>
                      <ul>
                        <li>
                          All content (lessons, videos, tests, etc.) is owned by Academia
                          Platform and licensed from our partners.
                        </li>
                        <li>
                          Purchasing a course grants you a limited, non-transferable
                          license for personal use only.
                        </li>
                        <li>
                          Content may not be reproduced, distributed, or publicly
                          displayed without permission.
                        </li>
                      </ul>

                      <h5 style="font-weight: 700" class="fw-bold mt-4 text-dark">
                        4. Payments and Refunds
                      </h5>
                      <ul>
                        <li>
                          Some services are free, while others require a subscription fee.
                        </li>
                        <li>
                          Prices are shown before subscription and may change at our
                          discretion.
                        </li>
                        <li>
                          Refund policies will be clearly displayed at payment. Unless
                          otherwise stated, subscriptions are non-refundable.
                        </li>
                        <li>
                          Subscription duration is determined by us and the instructor.
                          You may inquire about the validity period of the subscription
                          and contact technical support before subscribing.
                        </li>
                      </ul>

                      <h5 style="font-weight: 700" class="fw-bold mt-4 text-dark">
                        5. Instructor Terms
                      </h5>
                      <ul>
                        <li>
                          If you provide content, you grant us a license to host, use,
                          distribute, and promote it on the platform.
                        </li>
                        <li>
                          You are responsible for ensuring your content complies with laws
                          and does not infringe third-party rights.
                        </li>
                      </ul>

                      <h5 style="font-weight: 700" class="fw-bold mt-4 text-dark">
                        6. Intellectual Property
                      </h5>
                      <p class="text-dark">
                        All content, trademarks, logos, and platform features are owned by
                        Academia Platform. Our intellectual property may not be used
                        without prior written permission.
                      </p>

                      <h5 style="font-weight: 700" class="fw-bold mt-4 text-dark">
                        7. Privacy
                      </h5>
                      <p class="text-dark">
                        Your use of the services is also governed by our Privacy Policy.
                        We may collect and process personal data to operate and improve
                        the services.
                      </p>

                      <h5 style="font-weight: 700" class="fw-bold mt-4 text-dark">
                        8. Termination of Service
                      </h5>
                      <ul>
                        <li>
                          We may suspend or terminate your account if you violate these
                          terms.
                        </li>
                        <li>
                          Students may delete their accounts at any time by contacting
                          support.
                        </li>
                      </ul>

                      <h5 style="font-weight: 700" class="fw-bold mt-4 text-dark">
                        9. Disclaimer
                      </h5>
                      <ul>
                        <li>
                          We do not guarantee that courses or content will meet your
                          expectations.
                        </li>
                        <li>
                          We are not responsible for discussions inside private instructor
                          groups.
                        </li>
                        <li>
                          We are not responsible for providing curricula in the form of
                          notes, books, or PDF files; this depends on the instructor if
                          they choose to provide them.
                        </li>
                        <li>Services are provided “as is” without warranties.</li>
                      </ul>

                      <h5 style="font-weight: 700" class="fw-bold mt-4 text-dark">
                        10. Limitation of Liability
                      </h5>
                      <p class="text-dark">
                        To the maximum extent permitted by law, we are not liable for any
                        indirect or consequential damages.
                      </p>

                      <h5 style="font-weight: 700" class="fw-bold mt-4 text-dark">
                        11. Changes to the Terms
                      </h5>
                      <p class="text-dark">
                        We may update these terms from time to time. Continued use of the
                        services after changes means you accept the updated terms.
                      </p>

                      <h5 style="font-weight: 700" class="fw-bold mt-4 text-dark">
                        12. Contact Us
                      </h5>
                      <p class="text-dark">
                        For inquiries, you can reach us via:
                        <a
                          href="https://t.me/Academia_messeges_bot"
                          target="_blank"
                          class="fw-semibold"
                          >Support bot</a
                        >
                      </p>
                      <p class="text-dark">
                        📍 Location: Academia Center – University Branch, opposite the
                        Engineering Faculty Halls at the University of Tripoli, next to
                        the external fence of the University Mosque.
                      </p>

                      <a
                        href="https://maps.apple.com/?auid=14457113495649267365&ll=32.857007,13.215420&lsp=7618&q=Dropped%20Pin&t=m"
                        target="_blank"
                        style="font-size: 13px !important; padding: 10px !important"
                        class="btn btn-success mt-3 px-4 py-2 fw-bold fs-6 rounded-pill d-inline-flex align-items-center shadow-sm"
                      >
                        <i
                          class="fas fa-location-dot me-2 fs-5"
                          style="margin-right: 5px"
                        ></i>
                        View on Map
                      </a>
                    </div>
                  </div>
                </div>
                <!-- end row -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end::Content-->
  </div>
</template>

<script>
export default {
  name: "TermsOfService",
};
</script>

<style scoped>
/* العمود الأيسر (العربي) */
.terms-col-ar {
  border-left: 0px solid #198754; /* أخضر */
  padding-left: 20px;
}

/* العمود الأيمن (الإنجليزي) */
.terms-col-en {
  border-right: 2px solid #00a81cff; /* أخضر */
  padding-right: 20px;
}

/* نخفي الحدود في الموبايل */
@media (max-width: 991.98px) {
  .terms-col-ar,
  .terms-col-en {
    border: none;
    padding: 0;
  }
}

/* تحسين النصوص */
.terms-content {
  line-height: 1.5;
  font-size: 15px;
  color: #333;
}

.terms-content h5 {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 6px;
  margin-bottom: 12px;
}
</style>
